import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import ChangeRateCode from './ChangeRateCode';
import * as orderActions from './../../../../../../actions/orderAction';
import * as RateCodeAction from './../../../../../../actions/rateCodeAction';

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,
        rateCodeState: state.rateCodeReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeRateCode: (change) => dispatch(orderActions.changeRateCode(change)),
        getRateCodeListAll: (params) => dispatch(RateCodeAction.getRateCodeListAll(params)),
        getRateCodeListWithPaging: (params, payload) => dispatch(RateCodeAction.getRateCodeListWithPaging(params, payload)),
        getRateCodeDetailCache: (id, payload) => dispatch(RateCodeAction.getRateCodeDetailCache(id, payload)),
        getRateCodeCampaignList: (data) => dispatch(RateCodeAction.getRateCodeCampaignList(data)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ChangeRateCode));
